import {Comment, getDocumentPartComments, useAppSelector} from '@dv5/domain'
import {useCallback, useState} from 'react'
import {documentApi} from '../services/documentService'

interface UseCommentsProps {
    documentId: string
    partId: string
}

interface UseCommentsReturn {
    showAddCommentDialog: boolean
    setShowAddCommentDialog: React.Dispatch<React.SetStateAction<boolean>>
    partComments: Record<string, Comment[]>
    loadComments: (sourceItemId: string) => void
    editComment: (commentId: string, content: string) => void
    sendComment: (content: string) => void
    deleteComment: (commentId: string) => void
}

export const useComments = ({
                                documentId,
                                partId,
                            }: UseCommentsProps): UseCommentsReturn => {
    const [showAddCommentDialog, setShowAddCommentDialog] = useState(false)
    const partComments = useAppSelector(getDocumentPartComments)

    const loadComments = useCallback((sourceItemId: string) => {
        documentApi.getPartComments(documentId, sourceItemId)
    }, [documentId])

    const editComment = useCallback((commentId: string, content: string) => {
        documentApi.editComment(documentId, commentId, content)
    }, [documentId])

    const sendComment = useCallback((content: string) => {
        documentApi.addComment(documentId, partId, content)
        setShowAddCommentDialog(false)
    }, [documentId, partId])

    const deleteComment = useCallback((commentId: string) => {
        documentApi.removeComment(documentId, partId, commentId)
    }, [documentId, partId])

    return {
        showAddCommentDialog,
        setShowAddCommentDialog,
        partComments,
        loadComments,
        editComment,
        sendComment,
        deleteComment,
    }
}
